/*!
 * ulloa-vehicle-state.js — GARAGE PERSISTENTE de Ulloa Motors.
 * Fuente única de verdad del vehículo elegido y del set de piezas compatibles.
 * Se carga en TODO el sitio (theme.liquid). Expone window.UlloaVehicle.
 *
 * Patrón inspirado en Repuestos Boston (Magento customer-data sections), pero
 * adaptado a Shopify: persistencia en localStorage (lectura instantánea, sin
 * recarga de página) + espejo opcional en cart attribute para el checkout.
 *
 * Reglas del proyecto:
 *  - Cruce de stock contra Shopify (lo entrega el endpoint /api/fitment vía Redis).
 *  - Solo Hyundai/Kia por patente/VIN; SsangYong por marca/modelo. Otra marca -> WhatsApp.
 *  - Normalizar OEM (guion + sufijo "A" alternativo). NO inventar datos.
 */
(function (w, d) {
  'use strict';
  if (w.UlloaVehicle) return; // idempotente: no re-definir ni perder suscriptores si se carga dos veces

  var CFG = w.UlloaFitment || {};
  var ENDPOINT = CFG.endpoint || w.ULLOA_FITMENT_ENDPOINT || 'https://crm.ulloamotors.cl/api/fitment';
  var WA = CFG.whatsapp || '56988856787';
  var SET_TTL_MS = (CFG.setTtlMinutes || 30) * 60 * 1000;
  var CART_MIRROR = CFG.cartMirror === true; // opt-in: escribe el vehículo como atributo del carro

  var K_VEHICLE = 'ulloa_vehicle';
  var K_SET = 'ulloa_fitment_set';
  var K_GARAGE = 'ulloa_garage';   // array (multi-vehículo, máx 4) — listo desde el día 1
  var K_ONLYFITS = 'ulloa_only_fits';
  var K_FULL = 'ulloa_fitment_full'; // lista deduplicada completa (para buscar dentro del auto, estilo Boston)
  var GARAGE_MAX = 4;

  var subs = [];
  /* analítica (aditivo, no toca matching/dedup): espejo a ufTrack si existe */
  function _track(n, p) { try { (w.ufTrack || function () {})(n, p); } catch (e) {} }
  function _mth(p) { return p.plate ? 'patente' : (p.vin ? 'chasis' : 'modelo'); }
  var lastRaw = null; // última respuesta cruda del endpoint (para la vista de resultados sin re-fetch)
  var _inflight = {}; // qs -> Promise: consultas idénticas simultáneas comparten UNA llamada de red

  /* ---------- helpers de almacenamiento ---------- */
  function read(k) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function del(k) { try { localStorage.removeItem(k); } catch (e) {} }

  /* ---------- display ---------- */
  function titleCase(s) {
    return (s || '').toString().toLowerCase().replace(/\b([a-záéíóúñ])/g, function (m) { return m.toUpperCase(); });
  }
  // "ACCENT/ACCENT BLUE/VERNA/PONY" -> "Accent"
  function cleanModel(model) {
    var first = (model || '').toString().split('/')[0].trim();
    return titleCase(first) || (model || '');
  }
  function handleFromUrl(url) {
    if (!url) return '';
    var m = url.toString().split('/products/')[1];
    return m ? m.split(/[?#]/)[0].toLowerCase() : '';
  }
  function vehicleLabel(v) {
    // Fallback 'auto': si la patente matchea piezas por vin_squish pero el backend no
    // resuelve marca/modelo, NUNCA renderizar label vacío ("para tu " / "de tu ").
    return [titleCase(v.brand), cleanModel(v.model), v.year].filter(Boolean).join(' ') || 'auto';
  }

  /* ---------- dedup/scoring + set: AHORA EN EL SERVIDOR (fitment_shape.py) ----------
     El endpoint ya devuelve la respuesta deduplicada (1 fila por OEM) y el set del sitio
     (fits.handles). El cliente solo pinta: ya no viaja el algoritmo ni las variantes crudas. */
  function buildSetFrom(data) {
    return { veh_key: data.veh_key || null, ts: Date.now(),
             handles: (data.fits && data.fits.handles) || [] };
  }

  /* ---------- pub-sub ---------- */
  function notify() {
    var v = api.get(), s = api.getSet();
    subs.forEach(function (fn) { try { fn(v, s); } catch (e) {} });
    try { d.dispatchEvent(new CustomEvent('ulloa:vehicle', { detail: { vehicle: v, set: s } })); } catch (e) {}
  }

  /* ---------- espejo en cart attribute (opt-in) ---------- */
  function mirrorToCart(v) {
    if (!CART_MIRROR || !w.fetch) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Vehículo': vehicleLabel(v), '_ulloa_vin': v.veh_key || '' } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- API pública ---------- */
  var api = {
    endpoint: ENDPOINT,
    whatsapp: WA,
    cleanModel: cleanModel, vehicleLabel: vehicleLabel,
    handleFromUrl: handleFromUrl,

    get: function () { return read(K_VEHICLE); },
    getSet: function () {
      var s = read(K_SET), v = read(K_VEHICLE);
      if (!s || !v) return null;
      if (s.veh_key && v.veh_key && s.veh_key !== v.veh_key) return null;
      if ((Date.now() - (s.ts || 0)) > 6 * 60 * 60 * 1000) return null; // demasiado viejo: no afirmar calce con datos vencidos
      return s;
    },
    // Lista deduplicada COMPLETA del auto (para buscar "solo lo de mi vehículo", estilo Boston).
    getFull: function () {
      var f = read(K_FULL), v = read(K_VEHICLE);
      if (!f || !v) return null;
      if (f.veh_key && v.veh_key && f.veh_key !== v.veh_key) return null;
      if ((Date.now() - (f.ts || 0)) > 6 * 60 * 60 * 1000) return null;
      return f.deduped;
    },
    getGarage: function () { return read(K_GARAGE) || []; },
    hasVehicle: function () { return !!read(K_VEHICLE); },
    onChange: function (fn) { if (typeof fn === 'function') { subs.push(fn); } return api; },

    onlyFits: function (val) {
      if (typeof val === 'boolean') { write(K_ONLYFITS, val); notify(); return val; }
      var s = read(K_ONLYFITS); return s === null ? (CFG.onlyFitsDefault === true) : s;
    },

    // Guarda el vehículo + set y avisa a todo el sitio (sin recargar). `raw` = respuesta cruda del endpoint.
    setVehicle: function (vehicle, raw) {
      var v = {
        veh_key: vehicle.veh_key || null,
        vin: vehicle.vin || null, // VIN completo (17) si el backend lo entrega; para el lead de WhatsApp
        brand: vehicle.brand || '', model: vehicle.model || '', year: vehicle.year || '',
        label: vehicleLabel(vehicle), savedAt: Date.now(),
        refining: !!vehicle.refining, source: vehicle.source || '',
        query: vehicle.query || null // para re-hidratar la vista de resultados tras navegar
      };
      write(K_VEHICLE, v);
      if (raw) write(K_SET, buildSetFrom(raw));
      // garage multi-vehículo
      var garage = (read(K_GARAGE) || []).filter(function (g) { return g.veh_key !== v.veh_key || !v.veh_key; });
      garage.unshift(v); write(K_GARAGE, garage.slice(0, GARAGE_MAX));
      mirrorToCart(v);
      // Si la URL trae ?uf=all (catálogo completo) y se fija un auto NUEVO, el usuario quiere FILTRAR:
      // soltamos el param (replaceState) para que apply() pinte la vista del vehículo, no el catálogo
      // completo. (Antes re-agregar el auto con uf=all pegado "no filtraba".)
      try { if (/[?&]uf=all\b/i.test(location.search)) { var u = new URL(location.href); u.searchParams.delete('uf'); w.history.replaceState(null, '', u.pathname + (u.search || '') + u.hash); } } catch (e) {}
      notify();
      return v;
    },

    clear: function () { del(K_VEHICLE); del(K_SET); del(K_ONLYFITS); del(K_FULL); notify(); },

    useFromGarage: function (veh_key) {
      var g = read(K_GARAGE) || [], hit = g.filter(function (x) { return x.veh_key === veh_key; })[0];
      if (!hit) return null;
      // del K_FULL: al cambiar de auto desde el garaje, NO dejar la lista completa del auto anterior
      // (getFull la devolvería para autos sin vin_squish → pintaría las piezas del auto equivocado).
      // El refetch silencioso de abajo re-popula K_FULL del auto nuevo.
      write(K_VEHICLE, hit); del(K_SET); del(K_FULL); notify();
      // re-hidrata el set en background con la MISMA consulta original (no el modelo crudo)
      if (hit.query) { var q = {}; Object.keys(hit.query).forEach(function (k) { if (hit.query[k] != null) q[k] = hit.query[k]; }); q._silent = true; api.search(q); }
      return hit;
    },

    lastResult: function () { return lastRaw || null; },  // lastRaw ya viene deduplicado del server

    // Re-consulta el endpoint con la query original guardada (para la vista de resultados tras navegar).
    refetch: function () {
      var v = api.get();
      if (!v || !v.query) return Promise.resolve({ ok: false, status: 'no_query' });
      var q = {}; Object.keys(v.query).forEach(function (k) { if (v.query[k] != null) q[k] = v.query[k]; });
      q._silent = true; // refresca el set sin reescribir el vehículo activo; igual devuelve deduped para la vista
      return api.search(q);
    },

    // Llama al endpoint, persiste y notifica. Devuelve Promise<{ok, deduped|reason|status}>.
    search: function (params) {
      var q = [];
      if (params.plate) q.push('plate=' + encodeURIComponent(params.plate));
      else if (params.vin) q.push('vin=' + encodeURIComponent(params.vin));
      else if (params.brand && params.model) {
        q.push('brand=' + encodeURIComponent(params.brand));
        q.push('model=' + encodeURIComponent(params.model));
        if (params.year) q.push('year=' + encodeURIComponent(params.year));
      } else {
        return Promise.resolve({ ok: false, status: 'no_input', reason: 'Ingresa patente, chasis o marca/modelo.' });
      }
      // DEDUP EN VUELO: consultas idénticas simultáneas (doble submit, componentes en paralelo)
      // comparten UNA llamada de red; cada caller procesa la MISMA respuesta con su propia
      // semántica (_silent, tracking). NO toca el caché localStorage ni el gate refining.
      var qs = q.join('&');
      var netP = _inflight[qs];
      if (!netP) {
        var _ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var _to = _ctrl ? setTimeout(function () { try { _ctrl.abort(); } catch (e) {} }, 12000) : null;
        netP = fetch(ENDPOINT + '?' + qs, { headers: { 'Accept': 'application/json' }, signal: _ctrl ? _ctrl.signal : undefined })
          .then(function (r) { if (_to) clearTimeout(_to); delete _inflight[qs]; return r.json(); },
                function (e) { if (_to) clearTimeout(_to); delete _inflight[qs]; throw e; });
        _inflight[qs] = netP;
      }
      return netP
        .then(function (data) {
          if (!data || !data.ok) {
            if (!params._silent) _track('fitment_search', { method: _mth(params), status: (data && data.status) || 'error', ok: false });
            return { ok: false, status: data && data.status, reason: (data && data.reason) || 'No pudimos identificar tu auto.' };
          }
          // GATE DE CONFIANZA: el backend marca status:"refining" cuando decodifico el VIN pero NO esta
          // seguro del vehiculo (VIN tipeado mal / sin match real en el padron / modelo incompleto).
          // En una busqueda iniciada por el usuario NO fijamos un vehiculo activo en ese caso: evita
          // mostrar "auto" o un auto equivocado (p.ej. un VIN invalido que igual decodifica a una marca).
          // Los VIN coreanos NO usan el digito verificador norteamericano, asi que no se puede validar por
          // checksum; nos guiamos por la confianza que reporta el backend (status "ok" vs "refining").
          if (!params._silent && data.status === 'refining') {
            _track('fitment_search', { method: _mth(params), status: 'refining', ok: false });
            return { ok: false, status: 'refining', reason: 'No pudimos identificar tu auto con certeza. Revisa el N° de chasis (17 caracteres) o búscalo por marca y modelo.' };
          }
          lastRaw = data;
          var deduped = data;              // el endpoint ya devuelve deduplicado + payload mínimo
          var dataVin = data.veh_key;
          if (params._silent) {
            // GUARDA anti-carrera: si el vehículo activo cambió mientras el refetch silencioso
            // estaba en vuelo, NO sellar K_FULL/K_SET (evita afirmar el calce del auto equivocado).
            var curV0 = read(K_VEHICLE);
            if (curV0 && curV0.veh_key && dataVin && curV0.veh_key !== dataVin) {
              return { ok: false, status: 'stale' };
            }
          }
          try { write(K_FULL, { veh_key: dataVin, ts: Date.now(), deduped: deduped }); } catch (e) {}
          if (!params._silent) {
            var query = { plate: params.plate || undefined, vin: params.vin || undefined,
                          brand: params.brand || undefined, model: params.model || undefined, year: params.year || undefined };
            var veh = Object.assign({}, data.vehicle, { veh_key: data.veh_key, refining: data.refining, query: query,
              source: params.plate ? 'patente' : (params.vin ? 'chasis' : 'modelo') });
            api.setVehicle(veh, data);
            _track('fitment_search', { method: veh.source, status: data.status || 'ok', ok: true, results: data.total || 0 });
            _track('vehicle_applied', { method: veh.source, vehicle_label: vehicleLabel(veh) });
          } else if (data.vehicle) {
            // refresco silencioso: alinea el vin del set al vehículo activo (si no, getSet lo rechazaría) y avisa para re-pintar
            var setObj = buildSetFrom(data);
            var curV = read(K_VEHICLE);
            if (curV && curV.veh_key) setObj.veh_key = curV.veh_key;
            write(K_SET, setObj);
            notify();
          }
          return { ok: true, status: data.status, refining: data.refining, deduped: deduped, raw: data };
        })
        .catch(function () { if (_to) clearTimeout(_to); if (!params._silent) _track('fitment_search', { method: _mth(params), status: 'network_error', ok: false }); return { ok: false, status: 'error', reason: 'Tuvimos un problema de conexión. Intenta de nuevo o escríbenos por WhatsApp.' }; });
    },

    // ¿el set está vigente? (para re-fetch en background)
    setIsFresh: function () { var s = api.getSet(); return s && (Date.now() - s.ts) < SET_TTL_MS && !(read(K_VEHICLE) || {}).refining; },
    waLink: function (text) {
      // Adjunta SIEMPRE los datos del vehículo activo (patente + chasis 17 dígitos) para que
      // ventas reciba el lead completo desde CUALQUIER botón WhatsApp (compatible, predictivo, modal, PDP).
      var t = text || 'Hola! Necesito ayuda para encontrar repuestos de mi auto';
      var v = read(K_VEHICLE);
      if (v) {
        var q = v.query || {};
        if (q.plate) t += '\nPatente: ' + q.plate;
        var ch = v.vin || q.vin; // VIN real de 17 (del backend o el que escribió el cliente); NO el vin_squish
        if (ch) t += '\nN° chasis: ' + ch;
      }
      return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(t);
    }
  };

  w.UlloaVehicle = api;

  // Sync entre pestañas (Boston-style): si otra pestaña cambia el vehículo/set/toggle,
  // re-notifica a ESTA pestaña para re-pintar sin recargar.
  try {
    w.addEventListener('storage', function (e) {
      if (!e || e.key === null || e.key === K_VEHICLE || e.key === K_SET || e.key === K_ONLYFITS || e.key === K_FULL) notify();
    });
  } catch (e) {}

  // Re-hidratación en background (stale-while-revalidate): si hay vehículo y el set venció o estaba
  // refinando, refresca con la consulta original guardada (sirve para patente, VIN y marca/modelo).
  try {
    var v0 = api.get();
    if (v0 && v0.query && !api.setIsFresh()) api.refetch();
  } catch (e) {}

  // Señal para los componentes inline (que parsean ANTES que este script con defer).
  w.UlloaVehicleReady = true;
  try { d.dispatchEvent(new Event('ulloa:ready')); } catch (e) {}
})(window, document);
